import useProgressaoForm from "../../../hooks/useProgressaoForm";
import { formatDatePtBr } from "../../../utils/dateUtils";
import Button from "../../Button";
import {
  Background,
  Cardo,
  CursoTurmaDiscInfo,
  DivMain,
  DivSave,
  DivTitle,
  Infos,
  ResumoInfo,
} from "../CardAddEditProgressao/style";

function CardVerInformacoes({ show, setShow, progressaoEdit }) {
  if (!show) return;
  const curso = progressaoEdit?.curso_rh
    ?.split(",")[1]
    .replace(/(TÉCNICO EM|TECNÓLOGO EM)/g, "")
    .trim();
  const turma = progressaoEdit?.turma_rh?.split(",")[1].split("-").slice(1).join(" - ")?.trim();
  const disciplina = progressaoEdit?.disciplina_rh?.split(", ")[1]?.trim();

  return (
    <Background>
      <Cardo>
        <DivTitle>
          <h1>Informações Progressão Parcial</h1>
        </DivTitle>
        <DivMain style={{ display: "block", overflowY: "auto" }}>
          <Infos style={{ overflow: "hidden", minHeight: "150px" }}>
            <CursoTurmaDiscInfo>
              Curso <p>{curso}</p>
            </CursoTurmaDiscInfo>
            <CursoTurmaDiscInfo>
              Turma <p>{turma}</p>
            </CursoTurmaDiscInfo>
            <CursoTurmaDiscInfo>
              Disciplina <p>{disciplina}</p>
            </CursoTurmaDiscInfo>
            <CursoTurmaDiscInfo>
              Início da Progressão <p>{formatDatePtBr(progressaoEdit?.data_inicio)}</p>
              {/* <Input
                    color="#000000"
                    widthDiv="10.5rem"
                    placeholdercolor="#000000"
                    type="date"
                    whiteSpace="nowrap"
                    required={true}
                    disabled={true}
                  /> */}
            </CursoTurmaDiscInfo>
            <CursoTurmaDiscInfo>
              Limite de Entrega <p>{formatDatePtBr(progressaoEdit?.data_fim)}</p>
              {/* <Input
                    color="#000000"
                    widthDiv="9rem"
                    placeholdercolor="#000000"
                    type="date"
                    whiteSpace="nowrap"
                    required={true}
                    disabled={true}
                  /> */}
            </CursoTurmaDiscInfo>
          </Infos>
          <Infos $resumo={true} style={{ overflow: "hidden", minHeight: "150px" }}>
            <ResumoInfo>
              I. Competências/Habilidades esperadas: <p>{progressaoEdit?.competencias_habilidades}</p>
            </ResumoInfo>
            <ResumoInfo>
              II. Conhecimentos conteúdos: <p>{progressaoEdit?.conhecimento_conteudos}</p>
            </ResumoInfo>
            <ResumoInfo>
              III. Metodologia e procedimentos didáticos: <p>{progressaoEdit?.metodologia}</p>
            </ResumoInfo>
            <ResumoInfo>
              IV. Critérios de avaliação: <p>{progressaoEdit?.criterios_avaliacao}</p>
            </ResumoInfo>
            <ResumoInfo>
              V. Cronograma das etapas (períodos - atividades): <p>{progressaoEdit?.cronogramas_etapas}</p>
            </ResumoInfo>
            <ResumoInfo>
              VI. Material de apoio didático para os alunos: <p>{progressaoEdit?.material_apoio}</p>
            </ResumoInfo>
            <ResumoInfo>
              VII. Observações para o aluno: <p>{progressaoEdit?.orientacoes}</p>
            </ResumoInfo>
          </Infos>
        </DivMain>
        <DivSave>
          <Button
            event={() => setShow(false)}
            width="8rem"
            placeholder={"Fechar"}
            background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
            borderRadius="10px"
          />
        </DivSave>
      </Cardo>
    </Background>
  );
}

export default CardVerInformacoes;
